'use client'

// The register box is for visitors without an account. It arrives server-rendered (what crawlers
// and logged-out visitors see) and is taken away once the hydrated session shows a member.
import React from 'react'
import { useSupabaseAuth } from '@/context/supabaseContext'
import { SUPABASE_CONFIGURED } from '@/lib/supabase/client'

export function SignedOutOnly({ children }: { children: React.ReactNode }) {
  const { user, isLoaded } = useSupabaseAuth()
  if (SUPABASE_CONFIGURED && isLoaded && user) return null
  return <>{children}</>
}
